export default Object.freeze({
  K1: 'K1',
  K4: 'K4',
  K5: 'K5',
  SY: 'SY',
  ZV: 'ZV',
  ZO: 'ZO'
})
